import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { OnChangeFn, SortingState } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@model/enum/state.enum';

import {
  CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_LIST,
  CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_ORDER,
  CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_VISIBILITY,
} from './charge-point-channel-transaction-list.config';

interface ChargePointChannelTransactionListViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<TransactionModel>;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationOffsetNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
}

export const ChargePointChannelTransactionListView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
}: ChargePointChannelTransactionListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_LIST}
      columnOrder={CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_ORDER}
      columnVisibility={CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_VISIBILITY}
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.transaction-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
    />
  );
};
